module.exports = __webpack_public_path__ + "img/tag5.b4483a60.png";